module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-audio"
  }, [_c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.src
    },
    on: {
      "loadedmetadata": _vm.onLoadedmetadata,
      "canplay": _vm.onCanplay,
      "timeupdate": _vm.onTimeupdate
    }
  }, [_vm._v("\n\t\t您的浏览器版本过低，不识别audio标签\n\t")]), _vm._v(" "), _c('span', {
    class: ['status', _vm.status ? 'play' : 'pause'],
    on: {
      "click": _vm.onToggle
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time-c"
  }, [_vm._v(_vm._s(_vm.currentTime_f))]), _vm._v(" "), _c('span', {
    ref: "bar",
    staticClass: "bar",
    on: {
      "click": function($event) {
        return _vm.onBarClick($event)
      }
    }
  }, [_c('span', {
    staticClass: "buffer",
    style: ({
      width: _vm.bw_f
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "progress",
    style: ({
      width: _vm.pw_c_f
    })
  }), _vm._v(" "), _c('span', {
    ref: "dot",
    staticClass: "dot",
    style: ({
      left: _vm.dl_f
    }),
    on: {
      "touchstart": function($event) {
        return _vm.onStart($event)
      },
      "touchmove": function($event) {
        return _vm.onMove($event)
      },
      "touchend": function($event) {
        return _vm.onEnd($event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "time-t"
  }, [_vm._v(_vm._s(_vm.duration_f))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0977a42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/audio-bar.vue
// module id = 869
// module chunks = 2